<template>
  <div style="min-height: 92vh">
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h3>Traducción de productos</h3>
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="selectDep"
          label="Departamentos"
          item-text="Nombre"
          item-value="id"
          :items="departamentos"
        >
        </v-autocomplete>
      </v-col>

      <v-col>
        <v-autocomplete
          v-model="selectCategorie"
          label="Categorias"
          item-text="Nombre"
          item-value="id"
          :items="categorias"
        >
        </v-autocomplete>
      </v-col>

      <v-col>
        <v-btn color="primary" @click="searchInv">Buscar</v-btn>
      </v-col>

      <v-col>
        <v-autocomplete
          label="Filtro Traducciones"
          v-model="filtroTrad"
          item-text="nombre"
          item-value="id"
          :items="opcionesTrad"
          v-on:change="getPropToTranslate()"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" cols="12">
        <v-text-field v-model="filter" label="Filtrar"></v-text-field>
      </v-col>
      <v-col md="4" cols="12">
        <v-btn color="green" dark>
          <v-icon>mdi-file-excel-box</v-icon>
          <download-excel
            type="xls"
            name="Reporte Existencias"
            :data="excelData"
          >
            Exportar a Excel
          </download-excel>
        </v-btn>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th width="10%" class="text-center" v-show="filtroTrad != 0">
            Producto
          </th>
          <th width="10%" class="text-center">Categoría</th>
          <th width="20%" class="text-center">{{ traduccionHeader }}</th>
          <th width="55%" class="text-center">Traducir</th>
          <th width="5%"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(prod, index) in productosShow"
          :key="index"
          class="text-center"
        >
          <td v-show="filtroTrad != 0">{{ prod.Nombre }}</td>
          <td>{{ prod.categoria_name }}</td>

          <td>
            <v-tooltip bottom v-if="filtroTrad != 2">
              <template v-slot:activator="{ on, attrs }">
                <v-container
                  v-bind="attrs"
                  v-on="on"
                  @click="handleClickBoard(prod.id)"
                  style="cursor: pointer"
                  class="justify-center"
                  fill-height
                >
                  {{ getPropToTranslate(prod.id) }}

                  <span>
                    <v-icon small class="ml-1">
                      mdi-clipboard-multiple-outline
                    </v-icon>
                  </span>
                </v-container>
              </template>
              <span>Copiar al portapapeles</span>
            </v-tooltip>

            <div v-if="filtroTrad === 2">
              <template>
                <v-chip
                  class="ma-1"
                  color="light-blue darken-4"
                  text-color="white"
                  small
                  v-for="(item, index) in getPropToTranslate(prod.id)"
                  :key="index"
                >
                  {{ item }}
                </v-chip>
              </template>
            </div>
          </td>
          <td class="pa-5">
            <v-text-field
              v-show="filtroTrad === 0"
              v-model="prod.translateName"
              :error="prod.stateErrorName"
              :error-messages="prod.errorMessageName"
              mode="passive"
              outlined
              label="Traducción Nombre"
            >
            </v-text-field>
            <v-textarea
              v-show="filtroTrad === 1"
              v-model="prod.translateDscr"
              :error="prod.stateErrorDscr"
              :error-messages="prod.errorMessageDscr"
              label="Traducción Descripción"
              outlined
              auto-grow
              row-height="4"
            ></v-textarea>
            <v-combobox
              v-show="filtroTrad === 2"
              v-model="prod.translateTags"
              :error="prod.stateErrorTags"
              :error-messages="prod.errorMessageTags"
              label="Traducción Tags"
              :items="tags"
              hide-selected
              multiple
              small-chips
              solo
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip v-bind="attrs" :input-value="selected" label small>
                  <span class="pr-2">
                    {{ item }}
                  </span>
                  <v-icon small @click="parent.selectItem(item)">
                    $delete
                  </v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </td>
          <td>
            <v-btn
              @click="saveTrad(prod.id)"
              color="green darken-1"
              dark
              :loading="loaderSavingProducts == prod.id"
            >
              <v-icon small class="pr-1">mdi-content-save</v-icon>Guardar</v-btn
            >
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TraduccionCRUD",
  data() {
    return {
      loadingData: false,
      selectDep: "ALL",
      selectCategorie: "ALL",
      filter: "",
      processData: [],
      Categories: [],
      opcionesTrad: [
        {
          id: 0,
          nombre: "Nombre",
        },
        {
          id: 1,
          nombre: "Descripción",
        },
        {
          id: 2,
          nombre: "Tags",
        },
      ],
      filtroTrad: 0,
      tags: [],
      search: null,
      loaderSavingProducts: null,
      translateData: {},
    };
  },
  methods: {
    async searchInv() {
      this.loadingData = true;
      await this.getTraducciones();
      this.processData = [];
      let prod = this.$store.getters.getProductos;
      let productos = [];
      let aybProds = this.$pgsHelper.filterBy(prod, "Tipo", "AYB-Producto");
      aybProds = this.$pgsHelper.filterBy(aybProds, "Dlat", null);

      if (this.selectDep != "ALL") {
        productos = this.$pgsHelper.filterBy(
          aybProds,
          "Departamentos",
          this.selectDep,
          true
        );
      } else {
        productos = aybProds;
      }

      if (this.selectCategorie != "ALL") {
        productos = this.$pgsHelper.filterBy(
          productos,
          "Categoria",
          this.selectCategorie
        );
      }

      productos.forEach((item) => {
        let hashNombre = this.hashTexto(item.Nombre);
        let hashDscr = this.hashTexto(item.dscr);
        let tagsString = item.tags ? item.tags.join(", ") : "";
        let hashTags = this.hashTexto(tagsString);
        item.errorHashNombre = false;
        item.errorHashDscr = false;
        item.errorHashTags = false;

        item.categoria_name = this.getCategoryById(item.Categoria).Nombre;
        ///////////////////////////////////////////////////////
        /** Name */
        item.translateName = this.getTraduccionsById(
          item.id,
          "Nombre",
          hashNombre
        );
        item.errorHashNombre = this.hashHandle(item.id, "Nombre", hashNombre);
        item.stateErrorName = this.errorHandler(
          "Nombre",
          item.errorHashNombre,
          item.translateName
        );
        item.errorMessageName = this.messageHandler(
          "Nombre",
          item.errorHashNombre,
          item.translateName
        );
        ///////////////////////////////////////////////////////
        /** Descripción */
        item.translateDscr = this.getTraduccionsById(
          item.id,
          "Descripcion",
          hashDscr
        );
        item.errorHashDscr = this.hashHandle(item.id, "Descripcion", hashDscr);
        item.stateErrorDscr = this.errorHandler(
          "Descripcion",
          item.errorHashDscr,
          item.translateDscr
        );
        item.errorMessageDscr = this.messageHandler(
          "Descripcion",
          item.errorHashDscr,
          item.translateDscr
        );
        ///////////////////////////////////////////////////////
        /** Tags */
        item.translateTags = this.getTraduccionsById(item.id, "Tags", hashTags);
        item.errorHashTags = this.hashHandle(item.id, "Tags", hashTags);
        item.stateErrorTags = this.errorHandler(
          "Tags",
          item.errorHashTags,
          item.translateTags
        );
        item.errorMessageTags = this.messageHandler(
          "Tags",
          item.errorHashTags,
          item.translateTags
        );
      });

      this.processData = this.$_.orderBy(productos, "Nombre", "asc");
      this.loadingData = false;
    },
    getPropToTranslate(idSelected) {
      let prodToTranslate = this.$pgsHelper.getById(
        this.processData,
        "id",
        idSelected
      );
      let propToTranslate = "";
      if (this.filtroTrad == 0) {
        propToTranslate = prodToTranslate.Nombre;
      } else if (this.filtroTrad == 1) {
        propToTranslate = prodToTranslate.dscr;
      } else {
        propToTranslate = prodToTranslate.tags;
      }
      return propToTranslate;
    },
    saveTrad(idProducto) {
      this.loaderSavingProducts = idProducto;
      let product = this.$pgsHelper.getById(this.processData, "id", idProducto);

      let translateData = {
        ln: "en-us",
        tenant: this.$store.getters.getFirebaseApp.tenant,
        td: [],
      };
      try {
        if (product) {
          if (product.translateName !== "") {
            translateData.td.push({
              tp: "P",
              id: product.id,
              pt: "Nombre",
              or: product.Nombre,
              tr: product.translateName,
            });
          }
          if (product.translateDscr !== "") {
            translateData.td.push({
              tp: "P",
              id: product.id,
              pt: "Descripcion",
              or: product.dscr,
              tr: product.translateDscr,
            });
          }
          if (product.translateTags !== "") {
            let tagsEnString = product.tags.join(", ");
            let tagsEnStringTraducidas = product.translateTags.join(", ");
            translateData.td.push({
              tp: "P",
              id: product.id,
              pt: "Tags",
              or: tagsEnString,
              tr: tagsEnStringTraducidas,
            });
          }

          if (translateData.td.length != 0) {
            this.$store.getters.getFirebaseApp.fba
              .call("PDV-Traducciones-setTraducciones", translateData)
              .then((result) => {
                if (result.ok == false) {
                  this.$swal("Error", result.error, "error");
                } else {
                  this.searchInv();
                }
                this.loaderSavingProducts = null;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);

                this.loaderSavingProducts = null;
              });
          } else {
            this.loaderSavingProducts = null;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async handleClickBoard(idProducto) {
      let textToCopy = this.getPropToTranslate(idProducto);
      try {
        await navigator.clipboard.writeText(textToCopy);
      } catch (err) {
        console.error("Error al copiar: ", err);
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    async getTraducciones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Traducciones", [
        firestore.where(
          "tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("ln", "==", "en-us"),
        // firestore.where("departamento", "==", this.selectDep),
      ]);
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      this.translateData = document[0] ? document[0].td : [];
    },
    getTraduccionsById(code, tipoTraduccion, hash) {
      let valor = "P-" + code + "-" + tipoTraduccion;
      if (this.translateData[valor]) {
        if (hash == this.translateData[valor].h) {
          if (tipoTraduccion === "Tags") {
            let tagsTranslated = this.translateData[valor].t.split(", ");
            return tagsTranslated;
          }
          return this.translateData[valor].t;
        } else {
          // console.log(
          //   "Diferente hash",
          //   hash,
          //   "!=",
          //   this.translateData[valor].h,
          //   "ID:",
          //   code,
          //   "TIPO:",
          //   tipoTraduccion
          // );
          if (tipoTraduccion === "Tags") {
            let tagsTranslated = this.translateData[valor].t.split(", ");
            return tagsTranslated;
          }
          return this.translateData[valor].t;
        }
      } else {
        return "";
      }
    },
    hashTexto(texto) {
      if (texto) {
        const normalString = texto
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        const words = normalString.split(/[ ,]/);
        const val = words.map((word) => {
          let num = 0;
          for (let i = 0; i < word.length; i++) {
            const val = word.charCodeAt(i) - 97;
            // console.log(val)
            num += val;
          }
          return num.toString(36);
        });
        return val.join("").toUpperCase();
      } else {
        return "";
      }
    },

    hashHandle(code, tipoTraduccion, hash) {
      let valor = "P-" + code + "-" + tipoTraduccion;
      if (this.translateData[valor]) {
        const isSameHash = hash == this.translateData[valor].h;
        return !isSameHash;
      }
    },
    errorHandler(tipoTraduccion, bool, string) {
      if (bool == true) {
        return true;
      } else if (tipoTraduccion == "Tags") {
        return string.length <= 0;
      } else return string == "";
    },
    messageHandler(tipoTraduccion, bool, string) {
      if (tipoTraduccion == "Tags") {
        if (bool == true) {
          return "Traducción original cambió";
        } else if (string.length <= 0) {
          return "Coloque una traducción para Tags";
        }
      }
      if (tipoTraduccion == "Nombre") {
        if (bool == true) {
          return "Traducción original cambió";
        } else if (string == "") {
          return "Coloque una tradducción para Nombre";
        }
      }
      if (tipoTraduccion == "Descripcion") {
        if (bool == true) {
          return "Traducción original cambió";
        } else if (string == "") {
          return "Coloque una traducción para la descripción";
        }
      }
    },
  },
  computed: {
    productosShow() {
      let prods = this.processData;
      if (this.filter != "") {
        return prods.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      return prods;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    categorias() {
      let cat = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let categorias = this.Categories;
      categorias.forEach((ca) => {
        cat.push(ca);
      });
      return cat;
    },
    traduccionHeader() {
      let header = this.$pgsHelper.getById(
        this.opcionesTrad,
        "id",
        this.filtroTrad
      );
      if (!header) {
        return "NA";
      }
      return header.nombre;
    },
    excelData() {
      let ExcelData = [];
      this.processData.forEach((element) => {
        let DataProd = {
          Nombre: element.Nombre,
          Categoria: element.categoria_name,
          Descripción: element.dscr,
          Tags: element.tags,
          Traducción_Nombre: element.translateName,
          Traducción_Descripción: element.translateDscr,
          Traducción_Tags: element.translateTags,
        };
        ExcelData.push(this.$pgsHelper.cloneObj(DataProd));
      });
      //
      return ExcelData;
    },
  },
  created() {
    this.getCategories();
    //this.getTraducciones();
  },
};
</script>
